import { useQuery } from "convex/react";
import { api } from "../convex/_generated/api";

/**
 * Runtime toggle sourced from Convex (`feature_flags` key `heaven_hills_map_promo_ui`).
 * When enabled, map UI shows the Paloma Palooza promo (pill, sheet, filter).
 * Defaults to `false` while loading and when missing.
 */
export function useHeavenHillsMapPromoUiEnabled() {
  const isEnabled = useQuery(api.featureFlags.getHeavenHillsMapPromoUiEnabled);
  return isEnabled ?? false;
}
